import toPairs from 'lodash/toPairs.js';

/**
 * Replace ${var} placeholders in a string with values from supplied vars object
 * @param string {string} : 'My name is ${first} ${last}'
 * @param vars {object} : {first: 'Bob', last: 'Smith'}
 * @returns {string} : 'My name is Bob Smith'
 */

function replaceStringVars(string = '', vars = {}) {
  let text = string;
  toPairs(vars).forEach((entry) => {
    const [key, value] = entry;
    if (value !== undefined) {
      const keyLookup = new RegExp(`\\$\\{${key}\\}`, 'g');
      text = text.replace(keyLookup, value);
    }
  });

  return text;
}

export default replaceStringVars;
